import { cn } from "@/lib/utils";

/** As classes da pílula de filtro; o gatilho do dropdown de empresas usa as mesmas. */
export function filterPillClass(active: boolean): string {
  return cn(
    "rounded-full border px-3 py-1 text-[12px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#08254c] focus-visible:ring-offset-1",
    active
      ? "border-[#08254c] bg-[#08254c] text-white"
      : "border-[#d4dae3] bg-white text-[#3c4b61] hover:border-[#08254c]",
  );
}
